import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { iBackground, BackgroundBaseData } from '../../interfaces/background';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class BackgroundService {
  private data: tData;

  constructor(private title: Title) {
    this.data = {
      header: new BehaviorSubject<boolean>(BackgroundBaseData['header']),
      tall: new BehaviorSubject<boolean>(BackgroundBaseData['tall']),
      color: new BehaviorSubject<'#132847' | string>(BackgroundBaseData['color']),
      image: new BehaviorSubject<false | string>(BackgroundBaseData['image']),
      title: new BehaviorSubject<string>(BackgroundBaseData['title']),
      logo: new BehaviorSubject<'idf' | 'spokesperson' | false>(BackgroundBaseData['logo'])
    };
  }

  setValue(values: iBackground & { pageTitle?: string }) {
    // Make default
    Object.entries(this.data).forEach(([key, value]) => {
      (value as BehaviorSubject<any>).next(BackgroundBaseData[key]);
    });

    Object.keys(values).forEach(key => {
      if (key in BackgroundBaseData) this.data[key].next(values[key]);
    });

    let pageTitle = 'חטיבת דובר צה״ל';
    if (values.pageTitle && values.pageTitle.trim().length) pageTitle = `${values.pageTitle.trim()} | ${pageTitle}`;
    this.title.setTitle(pageTitle);
  }

  getValueSnapshot() {
    let pageTitle = this.title
      .getTitle()
      .split('|')[0]
      .trim();
    if (pageTitle === 'חטיבת דובר צה״ל') pageTitle = null;

    const obj: iBackground & { pageTitle?: string } = { pageTitle };
    Object.entries(this.data).forEach(([key, value]) => (obj[key] = value.getValue()));
    return obj;
  }

  getValue() {
    return this.data;
  }
}

type tSubject<T> = BehaviorSubject<T>;
type tData = { [key in keyof iBackground]: tSubject<iBackground[key]> };
